import styled from 'styled-components';

import { colors } from 'theme/colors';

export const StyledContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-top: none;
  border-radius: 0 0 8px 8px;
`;

export const StyledTitle = styled.p`
  padding: 24px 20px;
  margin: 0;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 32px */
  letter-spacing: 0.15px;
`;

export const StyledFooter = styled.p`
  display: flex;
  flex-direction: row;
  gap: 50px;
  align-items: center;
  justify-content: center;
  margin: 24px 20px;
  padding: 0;
  min-height: 40px;
  border-radius: 10px;
  background: ${({ theme }) => theme.tint.primary.medium};
  color: ${colors.ui.chip.grayText};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
`;
